import React, { useState } from "react";
import GuessMode from "../../components/poker/GuessMode";
import CalculateMode from "../../components/poker/CalculateMode";

type Mode = "guess" | "calculate";

export const PokerPage: React.FC = () => {
  const [mode, setMode] = useState<Mode>("guess");

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-emerald-950 to-gray-900 text-white">
      {/* Header */}
      <div className="pt-8 pb-4 text-center">
        <h1 className="text-2xl font-bold tracking-tight">
          Poker Odds Trainer
        </h1>
        <p className="text-gray-500 text-sm mt-1">Texas Hold'em</p>
      </div>

      {/* Mode tabs */}
      <div className="flex justify-center mb-6">
        <div className="bg-gray-800/60 rounded-xl p-1 flex gap-1">
          <button
            onClick={() => setMode("guess")}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all
              ${
                mode === "guess"
                  ? "bg-emerald-600 text-white shadow-md"
                  : "text-gray-400 hover:text-gray-200"
              }`}
          >
            Practice
          </button>
          <button
            onClick={() => setMode("calculate")}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all
              ${
                mode === "calculate"
                  ? "bg-emerald-600 text-white shadow-md"
                  : "text-gray-400 hover:text-gray-200"
              }`}
          >
            Calculator
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="px-4 pb-12 max-w-lg mx-auto">
        {mode === "guess" ? <GuessMode /> : <CalculateMode />}
      </div>
    </div>
  );
};
